import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { useUI } from "@/context/UIContext";
import { useAuth } from "@/context/AuthContext";
import { MyHomeRangeDashboard } from "@/components/MyHomeRangeDashboard";
import { MEDIA } from "@/lib/media";

export function Hero() {
  const { openAI, setBuildHuntOpen, openAuth } = useUI();
  const { isAuthed } = useAuth();
  const buildHunt = () => (isAuthed ? setBuildHuntOpen(true) : openAuth("register"));

  return (
    <section id="top" className="relative bg-charcoal text-bone overflow-hidden grain" data-testid="hero">
      <div className="absolute inset-0 z-0">
        <img
          src={MEDIA.homeHero}
          alt="A hunter looking out over a misty pine forest at golden hour"
          className="w-full h-full object-cover object-right"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal via-charcoal/85 to-charcoal/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-[1500px] mx-auto px-5 sm:px-10 grid lg:grid-cols-[1.05fr_.95fr] gap-10 items-center min-h-[calc(100vh-116px)] py-16 lg:py-0">
        <div className="flex flex-col justify-center max-w-2xl">
          <motion.span initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="hr-overline text-blaze" data-testid="hero-overline">
            The North American Hunting Hub
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.08 }}
            className="font-serif font-medium leading-[0.85] tracking-tight mt-4 mb-6 text-7xl sm:text-8xl lg:text-9xl"
            data-testid="hero-headline"
          >
            WELCOME<br />HOME.
          </motion.h1>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6, delay: 0.2 }} className="text-lg text-bone/80 leading-relaxed max-w-xl" data-testid="hero-subheadline">
            Your next hunt starts here. Plan it, build your gear, find trusted hunting services, understand the rules, and keep the story.
          </motion.p>
          <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.3 }} className="flex flex-wrap gap-3 mt-9">
            <button onClick={buildHunt} className="inline-flex items-center gap-2 bg-blaze text-white px-7 py-4 font-semibold uppercase tracking-wider text-sm hover:bg-blaze-light transition-colors" data-testid="hero-build-hunt">
              Build My Hunt <ArrowRight size={17} />
            </button>
            <button onClick={() => openAI()} className="inline-flex items-center gap-2 border border-bone/40 px-7 py-4 font-semibold uppercase tracking-wider text-sm hover:bg-bone hover:text-charcoal transition-colors" data-testid="hero-ask-ai">
              <Sparkles size={16} /> Ask HomeRange AI
            </button>
          </motion.div>
        </div>

        <div className="flex justify-center lg:justify-end">
          <MyHomeRangeDashboard />
        </div>
      </div>
    </section>
  );
}
